module.exports = __webpack_public_path__ + "static/media/disconnected.81d026c7.svg";